import { Text } from '@cinch-labs/design-system'
import { VehicleListing } from '@cinch-nx/data-search'
import styles from './carousel-section.module.css'
import { useFavouritesStore } from '@cinch-nx/data-favourites'
import { useEffect, useState } from 'react'
import { CarouselWithControls } from './carousel-with-controls'
import { SoldByPartnerInfo } from '@cinch-nx/feature-new-cars-drawer'

export interface CarouselSectionProps {
  title?: string
  disclaimer?: string
  vehicles?: VehicleListing[]
  onlyShowAvailableVehicles?: boolean
  showBrowseAllCarsCard?: boolean
  showMonthlyPrices?: boolean
}

export function CarouselSection({
  title,
  disclaimer,
  vehicles,
  onlyShowAvailableVehicles = true,
  showBrowseAllCarsCard = false,
  showMonthlyPrices,
}: CarouselSectionProps) {
  const { favourites, toggleFavourite } = useFavouritesStore()
  const [availableVehicles, setAvailableVehicles] = useState<VehicleListing[]>(
    [],
  )
  useEffect(() => {
    if (vehicles && onlyShowAvailableVehicles) {
      setAvailableVehicles(
        vehicles
          .filter((vehicle) => !vehicle.isReserved && vehicle.isAvailable)
          .slice(0, 6),
      )
    }
  }, [vehicles])

  if (availableVehicles?.length) {
    return (
      <section className={styles.container}>
        <div className={styles.header}>
          {title && (
            <Text
              className={styles.title}
              element={'h2'}
              fontSizeFixed={'xl'}
              fontWeight={'bold'}
            >
              {title}
            </Text>
          )}
          {disclaimer && (
            <div className={styles.disclaimerContainer}>
              <SoldByPartnerInfo
                callToActionClassName={styles.disclaimer}
                callToActionText={disclaimer}
              />
            </div>
          )}
        </div>

        <CarouselWithControls
          vehicles={availableVehicles}
          onSaveButtonClick={toggleFavourite}
          favourites={favourites
            .map((favourite) => (favourite.vehicle ? favourite.vehicle : null))
            .filter((vehicle) => !!vehicle)}
          showBrowseAllCarsCard={showBrowseAllCarsCard}
        />

        {showMonthlyPrices && (
          <div className={styles.representativeExampleContainer}>
            <strong>
              *Personal Contract Purchase (PCP) representative example:
            </strong>{' '}
            Based on an on the road price of &pound;31,738.63, with a
            &pound;2,800.00 customer deposit, borrowing &pound;28,938.63 at a
            representative APR of 3.5%. 49 monthly payments of &pound;349.00.
            Fixed rate of interest per annum 1.8%. Optional final payment
            &pound;15,318.00. Amount of interest &pound;3,131.37. Total amount
            payable &pound;34,870.00. Annual mileage limit 6,000 miles. Excess
            mileage charge 14.9p per mile. On the road price includes a retailer
            discount of &pound;1,576.37.
          </div>
        )}
      </section>
    )
  }

  return null
}

export default CarouselSection
